import { VaultInfo } from '../interfaces'
import { useVaultInfos } from './useVaultInfos'

export function useVaultInfo(vaultId: number, chainId: number): [VaultInfo | undefined, boolean] {
  const info = useVaultInfos({ fromVaultId: vaultId, toVaultId: vaultId, chainId })

  return [info?.data?.[vaultId], info?.isFetching || false]
}
